import $ from 'jquery';

const confirmDialogMessageQueue = [];
let modalVisible = false;

$(function () {

    let activeConfirmComponents;

    const $confirmModal = $(`
        <div id="confirmDialog" class="modal fade" aria-hidden="true" role="dialog" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-reject data-dismiss="modal">Mégse</button>
                        <button type="button" class="btn btn-danger" data-resolve data-dismiss="modal">Megerősítés</button>
                    </div>
                </div>
            </div>
        </div>
    `)
        .on('show.bs.modal', () => {
            modalVisible = true
        })
        .on('hide.bs.modal', () => {
            modalVisible = false
        })
        .on('hidden.bs.modal', () => {

            // First of all, check if the modal was cancelled
            // by any other way but the primary control button(s).
            if (activeConfirmComponents.deferred.state() === 'pending') {

                // If so, we'll interpret it as a rejection.
                activeConfirmComponents.deferred.reject();
            }

            // Continue showing further confirm messages..
            if (confirmDialogMessageQueue.length) {

                showNextConfirmMessage();
            }

        })
        .modal({
            show: false
        });

    $confirmModal
        .find('[data-reject]')
        .on('click', () => {

            activeConfirmComponents.deferred.reject();

            $confirmModal.modal('hide');
        });

    $confirmModal
        .find('[data-resolve]')
        .on('click', () => {

            activeConfirmComponents.deferred.resolve();

            $confirmModal.modal('hide');
        });

    function showNextConfirmMessage() {

        // Let's pop down the next upcoming message.
        activeConfirmComponents = confirmDialogMessageQueue.shift();

        // Boring UI stuff applied here.
        $confirmModal.find('.modal-header').html(activeConfirmComponents.title);
        $confirmModal.find('.modal-body').html(activeConfirmComponents.message);
        $confirmModal.modal('show');
    }

    window.confirmDialog = function (title, message) {

        return $.Deferred(function (deferred) {

            confirmDialogMessageQueue.push({
                title:    title,
                message:  message,
                deferred: deferred
            });

            if (!modalVisible) {

                showNextConfirmMessage();
            }

        }).promise();
    };
});

export default (title, message) => window.confirmDialog(title, message);
